import type { BadgeVariant } from '@/components/common/Badge';

/** Maps InComm Benepass transfer status strings to dashboard Badge variants. */
export function transferStatusBadgeVariant(status: string): BadgeVariant {
  const upper = status.toUpperCase();
  if (upper === 'SUCCESS') return 'success';
  if (upper === 'FAILED') return 'danger';
  if (upper === 'PENDING' || upper.startsWith('SKIPPED')) return 'warning';
  if (upper === 'SENT') return 'info';
  return 'default';
}
